import React from 'react'
import './App.css'
import Todo from './Components/Todo'

export default function App() {
  return (
    <div>
      <Todo />
    </div>
  )
}
